import React, { useState } from "react";
import { History, X, Loader2, ChevronDown, ChevronUp } from "lucide-react";

const fmtDate = (d) => {
  if (!d) return "";
  try { return new Date(`${d}T00:00:00`).toLocaleDateString([], { weekday: "short", month: "short", day: "numeric" }); }
  catch { return d; }
};

// Date-wise recap of earlier occurrences of this recurring meeting — so
// participants can quickly catch up on what happened last time before this
// session gets going. Only mounted when the shell knows the meeting is
// part of a series (see LiveTranscriptPanel's isRecurring check).
export default function HistoryPanel({ loading, occurrences, onClose }) {
  const [expanded, setExpanded] = useState(occurrences[0]?.id ?? null);

  return (
    <>
      <div style={{ padding: "16px 18px", borderBottom: "1px solid rgba(255,255,255,0.08)", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <History size={14} color="#00C8FF" />
          <span style={{ fontSize: 13, fontWeight: 700, color: "#E8F0FE" }}>Previous Sessions</span>
        </div>
        <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", color: "#7A93B4" }}><X size={15} /></button>
      </div>

      <div className="hm-scroll" style={{ flex: 1, overflowY: "auto", padding: "14px 18px" }}>
        {loading ? (
          <div style={{ display: "flex", alignItems: "center", gap: 8, color: "#7A93B4", fontSize: 12.5 }}>
            <Loader2 size={13} className="hm-spin" /> Loading history…
          </div>
        ) : occurrences.length === 0 ? (
          <div style={{ textAlign: "center", color: "#3D5473", fontSize: 12.5, marginTop: 40 }}>
            No completed sessions yet for this recurring meeting.
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {occurrences.map((o) => {
              const isOpen = expanded === o.id;
              return (
                <div key={o.id} className="hm-line" style={{ background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 10, overflow: "hidden" }}>
                  <button onClick={() => setExpanded(isOpen ? null : o.id)}
                    style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", padding: "10px 12px", background: "none", border: "none", cursor: "pointer" }}>
                    <div style={{ textAlign: "left" }}>
                      <div style={{ fontSize: 12, fontWeight: 700, color: "#E8F0FE" }}>{fmtDate(o.meeting_date)}</div>
                      <div style={{ fontSize: 10.5, color: "#7A93B4" }}>
                        {o.status}{o.action_items_count > 0 ? ` · ${o.action_items_count} action item${o.action_items_count > 1 ? "s" : ""}` : ""}
                      </div>
                    </div>
                    {isOpen ? <ChevronUp size={13} color="#7A93B4" /> : <ChevronDown size={13} color="#7A93B4" />}
                  </button>
                  {isOpen && (
                    <div style={{ padding: "0 12px 12px" }}>
                      {o.summary ? (
                        <p style={{ fontSize: 12, color: "#C8D6E8", lineHeight: 1.6, margin: "0 0 8px" }}>{o.summary}</p>
                      ) : (
                        <p style={{ fontSize: 11.5, color: "#3D5473", margin: "0 0 8px" }}>No summary — this session may not have a captured transcript.</p>
                      )}
                      {o.key_topics?.length > 0 && (
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 5 }}>
                          {o.key_topics.map((t, i) => (
                            <span key={i} style={{ fontSize: 10, padding: "2px 8px", borderRadius: 20, background: "rgba(124,92,255,0.15)", color: "#7C5CFF", fontWeight: 600 }}>{t}</span>
                          ))}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>

      <div style={{ padding: "10px 18px", borderTop: "1px solid rgba(255,255,255,0.06)", fontSize: 10.5, color: "#3D5473", textAlign: "center" }}>
        From earlier occurrences of this recurring meeting
      </div>
    </>
  );
}
